/**
 * Collapsed / expanded text styles for long product descriptions and part numbers in table
 * cells (quote, order, cart, shopping-list and checkout tables, `Shared/FastPathLink.tsx`).
 */
import { css } from "@emotion/react";
import { ITheme } from "@ryerson/frontend.theme";

/** One line, clipped with an ellipsis. */
export const nonExpandedContentCSS = css`
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
	white-space: nowrap;
`;

/** Full text, wrapping anywhere, in the theme's white. */
export const expandedContentCSS = (theme: ITheme) => css`
	color: ${theme.colors.primary.white};
	word-break: break-all;
`;
